$(".right-form").submit(function (e) {
  e.preventDefault();

  $.ajax({
    url: "/mail.php",
    method: "POST",
    data: $(this).serialize(),
    success: () => {
      $.fancybox.open({
        src: "#success",
        type: "inline",
      });

      setTimeout(() => {
        $.fancybox.close();
      }, 3000);
    },
  });
});

$(".form-call").submit(function (e) {
  e.preventDefault();

  $.ajax({
    url: "/mail.php",
    method: "POST",
    data: $(this).serialize(),
    success: () => {
      $.fancybox.close();

      $.fancybox.open({
        src: "#success",
        type: "inline",
      });

      setTimeout(() => {
        $.fancybox.close();
      }, 3000);
    },
  });
});

$(".form-popup").submit(function (e) {
  e.preventDefault();

  $.ajax({
    url: "/mail.php",
    method: "POST",
    data: $(this).serialize(),
    success: () => {
      closePopup();

      $.fancybox.open({
        src: "#success",
        type: "inline",
      });

      setTimeout(() => {
        $.fancybox.close();
      }, 3000);
    },
  });
});
